import { Component, EventEmitter, OnInit, Input, Output } from "@angular/core";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { SpinnerService } from "shared-components";
import { EtiquetadoService } from "../../../services/etiquetado.service";

@Component({
    selector: 'app-dsg-almacenes',
    templateUrl: './almacenes.component.html'
})
export class AlmacenesDesignacionComponent implements OnInit {

    public new = false;

    public almacenEditable;
    public almacenesList;
    public designacionesAlmacen;
    public almacenesDisponibles = [];
    public showCreate = true;

    private _filters;
    public toCloseSpinner = 0;

    @Input() etiquetadorId;
    @Input() designacionId;

    @Output() refresh = new EventEmitter<boolean>();
    @Output() pushMessage = new EventEmitter<string>();


    constructor(
        private readonly _sessionContext: SessionContextService,
        private readonly _spinnerService: SpinnerService,
        private readonly _etiquetadoService: EtiquetadoService
    ) { }

    ngOnInit() {
        this._filters = {
            etiquetadorId: this.etiquetadorId
        };
        this.getAlmacenesEtiquetador();
    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public get claims() {
        return this._sessionContext.sessionUser.lsClaimTypes;
    }

    public getAlmacenesEtiquetador() {
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._etiquetadoService.getAlmacenesEtiquetador(this._filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            this.almacenesList = resp.lista;
            this.getAsociacionesAlmacen();
        });
    }

    public getAsociacionesAlmacen() {
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._etiquetadoService.getDesignacionesAlmacen(this.designacionId).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            this.designacionesAlmacen = resp;
            if (this.designacionesAlmacen.length === this.almacenesList.length) {
                this.showCreate = false;
            } else {
                this.showCreate = true;
            }
        });
    }

    public toRefresh(value) {
        this.getAlmacenesEtiquetador();
        this.refresh.emit(value);
        this.almacenEditable = '';
        this.new = false;
    }

    private checkCloseSpinner() {
        this.toCloseSpinner -= 1;
        if (this.toCloseSpinner === 0) {
            this._spinnerService.hideSpinner();
        }
    }
}
